var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from './svg-circle-icon';
export var CropIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 57,
    glyphHeight: 57
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.84902 9.88748V3.12885C9.84902 1.52802 11.1467 0.2323 12.7456 0.2323C14.3445 0.2323 15.6421 1.52802 15.6421 3.12885V40.784H53.2973C54.8962 40.784 56.1939 42.0797 56.1939 43.6806C56.1939 45.2795 54.8962 46.5771 53.2973 46.5771H46.5387V53.3357C46.5387 54.9346 45.241 56.2323 43.6421 56.2323C42.0432 56.2323 40.7456 54.9346 40.7456 53.3357V46.5771H12.7456C11.1467 46.5771 9.84902 45.2795 9.84902 43.6806V15.6806H3.0904C1.4915 15.6806 0.193848 14.3829 0.193848 12.784C0.193848 11.1832 1.4915 9.88748 3.0904 9.88748H9.84902ZM19.5042 12.784C19.5042 11.1832 20.8019 9.88748 22.4007 9.88748H43.6441C45.243 9.88748 46.5406 11.1832 46.5406 12.784V34.0254C46.5406 35.6243 45.243 36.922 43.6441 36.922C42.0452 36.922 40.7475 35.6243 40.7475 34.0254V15.6806H22.4007C20.8019 15.6806 19.5042 14.3829 19.5042 12.784Z"
  }));
};
export var CropIconGlyph = function (props) {
  return React.createElement(CropIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};